export const defaultToast = { duration: 9000, isClosable: true };
